module.exports = __webpack_public_path__ + "img/gxlogo3.abcef79a.png";